import React from 'react';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormElements from '../../FormElements/FormElements';
import Text from '../../BuildingBlocks/Text';
import { HEADING_COLORS, colors, mixins, media, fonts } from '../../css';

export const StyledCollectionWrapper = styled.div`
  position: relative;
  padding: ${props => (props.propertyPane ? `${mixins.pxToRem(15)} 0` : `${mixins.pxToRem(20)} 0`)};
  width: 100%;
  background-color: ${colors.colorGrey05};
  ${media.greaterThan('lg')`
    padding: ${props => (props.propertyPane ? `${mixins.pxToRem(15)} ${mixins.pxToRem(15)}` : `${mixins.pxToRem(20)}`)}
  `};
`;

export const StyledCardWrapper = styled.div`
  padding-top: ${mixins.pxToRem(15)};
`;

export const StyledRoomInputWrapper = styled.div`
  width: ${props => (props.propertyPane ? `100%` : `30%`)};
  border: ${props => (props.propertyPane ? `none` : `1px solid ${colors.colorGrey04}`)};
  border-left: none;
  padding: ${props => (props.propertyPane ? `12px` : `16px`)} 20px 14px 20px;

  && {
    label {
      color: ${props => (props.hasValue ? colors.colorBlue : colors.colorGrey03)};
      ${props => (!props.hasValue ? 'margin-top: -7px;' : null)};
    }
  }
  &:focus,
  &:active,
  &:focus-within {
    box-shadow: inset 2px 2px 0 0 ${colors.colorBlue}, inset -2px -2px 0 0 ${colors.colorBlue};
    && {
      label {
        color: ${colors.colorBlue};
        ${props => (!props.hasValue ? 'margin-top: 2px;' : null)};
      }
    }
  }
`;

export const StyledRoomInput = styled(FormElements.TextInput)`
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  font-size: ${props => (props.propertyPane ? `12px` : `15px`)};
  height: ${mixins.pxToRem(47)};
  ${media.greaterThan('md')`
    font-size: 18px;
  `};

  input {
    font-family: ${fonts.fontMedium};
    padding-top: 3px;
    ${media.greaterThan('md')`
      padding-top: 0;
  `};
  }

  label {
    font-size: ${props => (props.propertyPane ? `12px` : `16px`)};
    margin-top: 2px;
  }
`;

export const StyledBookingInfoWrapper = styled.div`
  background-color: ${colors.colorWhite};
  display: flex;
  width: ${props => (props.propertyPane ? `100%` : `inherit`)};
  margin: 0;
  ${media.greaterThan('lg')`
  margin: 0 ${mixins.pxToRem(20)};
  `};
  align-content: center;
  ${media.greaterThan('md')`
    margin-left: auto;
    margin-right: auto;
    width: 340px;
  `};
  ${media.greaterThan('lg')`
    width: 100%;
  `};
`;

export const StyledContainerHeading = styled.h2`
  padding: 0 ${mixins.pxToRem(32)};
  ${media.greaterThan('md')`
    padding: 0 ${mixins.pxToRem(38)}
  `};
  ${media.greaterThan('lg')`
    padding: ${mixins.pxToRem(10)} 0 ${mixins.pxToRem(30)} 0 ; 
  `};
  font-family: ${fonts.fontBold};
  font-size: ${mixins.pxToRem(22)};
  color: ${colors.colorGrey02};
  letter-spacing: ${mixins.pxToRem(-0.55)};
  padding-bottom: ${mixins.pxToRem(20)};
`;

export const StyledPaneContainerHeading = styled(Text.HeadingFifth)`
  margin: 10px 0;
`;

const spreadSpinner = ({ spinnerColor, ...rest }) => <CircularProgress {...rest} />;
export const StyledSpinner = styled(spreadSpinner)`
  && {
    position: absolute;
    right: 15px;
    top: 20px;
    margin: 0px;
    color: ${props => HEADING_COLORS[props.spinnerColor] || colors.colorBlue};
  }
`;
